import { makeStyles } from "tss-react/mui";

import { Theme } from "@mui/material";

export const useStyles = makeStyles()((theme: Theme) => ({
    adornment: {
        marginTop: theme.spacing(2),
        "& .MuiOutlinedInput-root": {
            paddingLeft: 0,
        },
        "& .MuiInputAdornment-root": {
            padding: theme.spacing(5, 4),
            backgroundColor: theme.palette.emteria.background.paperDeep,
            borderTopLeftRadius: theme.shape.borderRadius,
            borderBottomLeftRadius: theme.shape.borderRadius,
        },
        pageTitleBox: {
            display: "flex",
        },
    },
    toolbar: {
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        marginBottom: theme.spacing(2),
        flexShrink: 0,
    },
    alertBox: {
        display: "inline-block",
        marginTop: theme.spacing(3),
    },
    popoverContentCotainer: {
        display: "flex",
        flexDirection: "column",
    },
}));
